import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

import mak_krishnagar from "../images/GET- TOGETHER 2024 mak.org.in Mountaineers’ Association of Krishnanagar.jpg";




function Mak() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <ScrollToTop smooth top="100" color="Gray"/>
            <div className='balajisareeblog'>
                <div className="album py-2">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/blog" href="#">All Blog</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Mountaineers’ Association of Krishnanagar</li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <br />


                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">

                                <h1 style={{ color: "#736f6fff" }} className='misaa'>  Mountaineers’ Association of Krishnanagar – My heartwarming experience
                                </h1>
                                <p>Read more about MAK and their inspiring journey. visit the official website: <a href='https://mak.org.in/'>https://mak.org.in/</a></p>
                                <p className='websitedevelopment mb-2' style={{ color: "grey" }}>The journey of building the website for Mountaineers’ Association of Krishnanagar (MAK) began with a meaningful and insightful discussion with the respected Debapriya Maity Sir. That conversation gave me a clear vision of the project and filled me with inspiration. Later, I had the privilege of discussing the concept further at the home of Shri Basanta Singha Roy Sir, which helped me deeply understand how the website should take shape.  </p>


                             
                            </div>
                            <div className="col-md-5">
                                          <img src={mak_krishnagar} className="d-block w-100" alt="Mountaineers’ Association of Krishnanagar"/>

                            
                            </div>
                               <p className='websitedevelopment' style={{ color: "grey" }}><small>Guided by the valuable suggestions and directions of Shri Basanta Singha Roy Sir, I began the development work. Every step of the process felt purposeful, as I was not only building a website but also connecting with a passionate and dedicated community. Once the website was completed, it was warmly appreciated by all the members of MAK. Their appreciation was truly an honor for me. I felt proud to have worked with such genuine and kind-hearted individuals.</small></p>
                                 <p className='websitedevelopment' style={{ color: "grey" }}><small>I was invited by Shri Ashim Kumar Mondal, Secretary of the association, to attend the Mountaineers’ Association of Krishnanagar Get Together 2024, held in Dignagar, Krishnagar. Attending this event was another memorable experience. The warmth, respect, and friendliness I received from everyone there deeply touched me. It wasn’t just an event—it felt like being part of a family.</small></p>
                                 <p>This entire experience has been far more than just a professional assignment. It became a journey filled with learning, respect, and human connection. I am truly honored to have contributed to something so meaningful.</p>
                        </div>
                        <br />
                        <h6 className='websitedevelopment mb-2' style={{ color: "grey" }}>Thank you, <b>Mountaineers’ Association of Krishnanagar</b>. Working with you has been one of the most rewarding chapters of my journey.</h6>

      

                        <br />
                        <h6><b>Team MR. INDIAN CODER</b></h6>
                    </div>
                </div>

                <br />

            </div>


        </div>
    )
}

export default Mak